import { instantLocal, partiesLocales } from '@artosera/shared';

export function dateHeureRdv(iso: string, fuseau: string) {
  const { date, heure } = partiesLocales(new Date(iso), fuseau);
  return `${date} ${heure}`;
}
export function saisieLocaleRdv(iso: string, fuseau: string) {
  return dateHeureRdv(iso, fuseau).replace(' ', 'T');
}
export function lireSaisieRdv(valeur: string, fuseau: string) {
  const [date, heure] = valeur.split('T');
  return date && heure ? (instantLocal(date, heure, fuseau)?.toISOString() ?? null) : null;
}
export function ajouterJoursRdv(date: string, jours: number) {
  const d = new Date(`${date}T12:00Z`);
  d.setUTCDate(d.getUTCDate() + jours);
  return d.toISOString().slice(0, 10);
}
export function periodeRdv(date: string, jours: number, fuseau: string) {
  if (!/^\d{4}-\d{2}-\d{2}$/.test(date)) return { du: '', au: '' };
  // Les bornes suivent les jours civils du fuseau, pas des durées de 24 heures.
  return {
    du:
      (instantLocal(date, '00:00', fuseau) ?? instantLocal(date, '01:00', fuseau))?.toISOString() ??
      '',
    au:
      (
        instantLocal(ajouterJoursRdv(date, jours), '00:00', fuseau) ??
        instantLocal(ajouterJoursRdv(date, jours), '01:00', fuseau)
      )?.toISOString() ?? '',
  };
}
